/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { TypescriptComponent } from 'components/typescriptExample'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import TextExpander from '../../components/textExpander'
import { Link } from '@ta-interaktiv/contentbricks'
import { Scrollchor } from 'react-scrollchor'

// TODO Set the correct article ID here
const ARTICLE_ID = '689153317769'

const isTabletGrid = window.innerWidth >= 600 && window.innerWidth <= 1200

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} inverted />
      <ThemeSwitch />

      <header className='ui vertical relaxed segment test'>
        <div className='gallery'>
          <div className='gradient' />
          <figure className='gallery__item gallery__item--1'>
            <img
              src={require('images/manuela-bieri.jpg')}
              className='gallery__img'
              alt='Image 1'
            />
          </figure>
          <figure className='gallery__item gallery__item--2'>
            <img
              src={require('images/bruno-bucher.jpg')}
              className='gallery__img'
              alt='Image 2'
            />
          </figure>
          <figure className='gallery__item gallery__item--3'>
            <img
              src={require('images/chantal-britt.jpg')}
              className='gallery__img'
              alt='Image 3'
            />
          </figure>
          <figure className='gallery__item gallery__item--4'>
            <img
              src={require('images/mirjam-luescher.jpg')}
              className='gallery__img'
              alt='Image 4'
            />
          </figure>
          <figure className='gallery__item gallery__item--5'>
            <img
              src={require('images/lara-karcher.jpg')}
              className='gallery__img'
              alt='Image 5'
            />
          </figure>
          <figure className='gallery__item gallery__item--6'>
            <img
              src={require('images/patrizia-lang.jpg')}
              className='gallery__img'
              alt='Image 6'
            />
          </figure>
          <figure className='gallery__item gallery__item--7'>
            <img
              src={require('images/genevieve-morin.jpg')}
              className='gallery__img'
              alt='Image 7'
            />
          </figure>
          <figure className='gallery__item gallery__item--8'>
            <img
              src={require('images/christian-salzmann.jpg')}
              className='gallery__img'
              alt='Image 8'
            />
          </figure>
          {isTabletGrid && (
            <figure className='gallery__item gallery__item--9'>
              <img
                src={require('images/sina-kuhn.jpg')}
                className='gallery__img'
                alt='Image 9'
              />
            </figure>
          )}
          <div className='ui container inverted headerWrapper'>
            <div className='ui header'>
              <h1>«Ich wünsche diese Krankheit meinem ärgsten Feind nicht»</h1>
              <h2>
                Wie zeigt man eine Krankheit, die fast unsichtbar ist? Fotograf
                Andreas Seibert porträtiert seit Sommer 2021
                Long-Covid-Betroffene und schrieb ihre Leidensgeschichten auf.
              </h2>
            </div>
          </div>
        </div>
      </header>

      {/* <header className='ui container titleImage'>
        <img src='images/baskast.jpg' />

        <div className='headline'>
          <h1>Ausser Atem</h1>
          <div className='byline'>
            Von chronischer Erschöpfung bis zu psychischen Krankheiten, die
            erneut ausbrechen: Die Folgen einer Coronainfektion können
            heimtückisch sein. Der Fotograf Andreas Seibert begleitet
            Long-Covid-Betroffene.
          </div>
        </div>
        <div className='author'>Andreas Seibert</div>
      </header> */}

      {/* <div className='ui container'>
          <div className='ta secondary caption'>
            {' '}
            Rechtsberaterin, Nationalrätin, Präsidentin der FDP: Petra Gössi.
            Foto: Joan Minder
          </div>
        </div> */}

      <div
        className='ui vertical fitted segment'
        style={{ paddingBottom: '0px' }}
      >
        <div className='ui text container inverted'>
          <div className='ta metainfo'>
            {/* <div className='ta author'>Andreas Seibert</div> */}
            <div className='ta updated'>Aktualisiert am 22. März 2022</div>
          </div>
          <div className='ta text'>
            <p>
              Long Covid hat allein in der Schweiz bisher Zehntausende aus ihrem
              Leben gerissen. Gemäss einer Kohortenstudie aus dem Kanton Zürich
              sind von Langzeitfolgen rund ein Viertel aller mit Corona
              Infizierten betroffen. 18 von 100 Personen sind sechs Monate nach
              einer Ansteckung noch leicht beeinträchtigt, 4 von 100
              mittelschwer und 3 von 100 sehr stark. Ob eine Infektion mit der
              Omikron-Variante seltener zu Long Covid führen wird, werden wir
              erst im Verlauf der nächsten Monaten sehen.
            </p>
            <p>
              Wie geht eine leistungsorientierte Gesellschaft mit Menschen um,
              welche die Leistung nicht mehr erbringen können?
              Dokumentar-Fotograf Andreas Seibert geht dieser Frage nach und
              porträtiert als Zeitdokument Long-Covid-Erkrankte im ganzen Land.
              Die Fotoserie, welche dereinst in einem Buchprojekt mit 80
              Porträts münden soll, soll kein Mitleid erregen, sondern
              Verständnis für die Situation der Betroffenen schaffen. Seibert
              verfasste neben den Fotografien auch Texte zu allen Personen.
            </p>
            <p>
              Am Ende des Beitrags finden Sie ein{' '}
              <Scrollchor to='#interview' animate={{ duration: 800 }}>
                <a href='#interview' className='linkTo'>
                  Interview
                  <i
                    className='angle double down icon small'
                    style={{ margin: 0, marginLeft: '2px' }}
                  />
                </a>
              </Scrollchor>{' '}
              mit dem Fotografen.
            </p>
          </div>
        </div>
      </div>
      {/* ZITAT */}
      <div className='ui relaxed vertical segment'>
        <div className='ui text container inverted'>
          <div className='ta text'>
            <div className='personName'>Manuela Bieri (41), Bern</div>
            <div className='personByline'>
              diplomierte Intensivpflegefachfrau
            </div>
          </div>
        </div>
        <div className='quoteWrapper'>
          <div className='row two left'>
            <div className='column image'>
              <img src={require('images/manuela-bieri.jpg')} />
              <div className='caption'>Foto: Andreas Seibert/Pro Litteris</div>
            </div>
            <div className='column text'>
              <div className='quote'>
                <div>
                  «Wir sterben nicht, wir müssen nicht ins Spital, wir sind für
                  niemanden wirklich interessant.»
                </div>
                <div className='byline'>Manuela Bieri (41)</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical segment portrait'>
        <div className='ui text container inverted'>
          <div className='ta text'>
            {/* <TextExpander
              trackingID='Manuela Bieri'
              shortText="
            <p>
              Manuela Bieri war vor ihrer Corona-Infektion mehrmals mit dem
              Schweizerischen Roten Kreuz (SRK) und dem IKRK in Krisengebieten
              unterwegs. In einem Feldspital eines riesigen Lagers nahe der
              Stadt Cox's Bazar in Bangladesh hat sie sich um Flüchtlinge aus
              Burma gekümmert. Sieben Tage die Woche hat Bieri alte
              Schussverletzungen und Traumata versorgt.
            </p>
            <p>
              In der zweiten Corona-Welle arbeitet Bieri als diplomierte
              Intensivpflegefachfrau im Spital und steckt sich wahrscheinlich
              dort mit Sars-CoV-2 an. Der Verlauf ihrer Corona-Infektion, die
              sie zu Hause durchmacht, ist mild. Nachdem sie sich erholt hat,
              beginnt Bieri wieder mit ihrer Arbeit. Wochen später beginnen ihre
              Long-Covid-Symptome, und sie wird zu 90 Prozent krankgeschrieben.
            </p>"
              longText='
              <p>
              Anfänglich hat Bieri Lungenprobleme, nun jedoch vor allem
              neurologische Störungen. Durch die kognitiven Einschränkungen ist
              sie vergesslich geworden und muss sich alles aufschreiben.
              Teilweise erkennt Bieri Bekannte nicht mehr. Konzentriert an einem
              Gespräch teilnehmen kann sie höchstens für eine Stunde. Sport zu
              treiben, ist ihr nicht mehr möglich. Maximal liegt ein Spaziergang
              von einer Stunde drin.
              </p>
              <p>
              Wenn sie ihre stark verminderte Leistungsgrenze überschreitet,
              leidet sie kurze Zeit später an Symptomen wie Fieber, Husten,
              Hals- und Gliederschmerzen und starkem Schwindel. Da sie hin und
              wieder etwas mit Freunden und mit ihrer Familie unternehmen will,
              nimmt sie diese Symptome gelegentlich in Kauf.
            </p>
            <p>
            «Wir sind für niemanden wirklich interessant, denn wir sterben
            nicht und müssen auch nicht stationär im Spital gepflegt werden»,
            sagt Bieri. Die Betroffenen sind in der Gesellschaft kaum
            sichtbar, denn sie meiden Menschenmengen und ziehen sich zurück,
            die Krankheit sieht man ihnen zudem auf den ersten Blick auch
            nicht an.
            </p>
            <p>
            Bieri hofft, dass die Schweizer Politik und die Medizin sich des
            Themas Long Covid ambitionierter annehmen werden. Aufgrund des
            komplexen Krankheitsbildes fühle sich bis jetzt niemand wirklich
            zuständig für sie; und wegen der fehlenden Sichtbarkeit würden
            Long-Covid-Betroffene oft vergessen.
            </p>
              '
            /> */}
            <p>
              Manuela Bieri war vor ihrer Corona-Infektion mehrmals mit dem
              Schweizerischen Roten Kreuz (SRK) und dem IKRK in Krisengebieten
              unterwegs. In einem Feldspital eines riesigen Lagers nahe der
              Stadt Cox's Bazar in Bangladesh hat sie sich um Flüchtlinge aus
              Burma gekümmert. Sieben Tage die Woche hat Bieri alte
              Schussverletzungen und Traumata versorgt.
            </p>
            <p>
              In der zweiten Corona-Welle arbeitet Bieri als diplomierte
              Intensivpflegefachfrau im Spital und steckt sich wahrscheinlich
              dort mit Sars-CoV-2 an. Der Verlauf ihrer Corona-Infektion, die
              sie zu Hause durchmacht, ist mild. Nachdem sie sich erholt hat,
              beginnt Bieri wieder mit ihrer Arbeit. Wochen später beginnen ihre
              Long-Covid-Symptome, und sie wird zu 90 Prozent krankgeschrieben.
            </p>
            <p>
              Anfänglich hat Bieri Lungenprobleme, nun jedoch vor allem
              neurologische Störungen. Durch die kognitiven Einschränkungen ist
              sie vergesslich geworden und muss sich alles aufschreiben.
              Teilweise erkennt Bieri Bekannte nicht mehr. Konzentriert an einem
              Gespräch teilnehmen kann sie höchstens für eine Stunde. Sport zu
              treiben, ist ihr nicht mehr möglich. Maximal liegt ein Spaziergang
              von einer Stunde drin.
            </p>
            <p>
              Wenn sie ihre stark verminderte Leistungsgrenze überschreitet,
              leidet sie kurze Zeit später an Symptomen wie Fieber, Husten,
              Hals- und Gliederschmerzen und starkem Schwindel. Da sie hin und
              wieder etwas mit Freunden und mit ihrer Familie unternehmen will,
              nimmt sie diese Symptome gelegentlich in Kauf.
            </p>
            <p>
              «Wir sind für niemanden wirklich interessant, denn wir sterben
              nicht und müssen auch nicht stationär im Spital gepflegt werden»,
              sagt Bieri. Die Betroffenen sind in der Gesellschaft kaum
              sichtbar, denn sie meiden Menschenmengen und ziehen sich zurück,
              die Krankheit sieht man ihnen zudem auf den ersten Blick auch
              nicht an.
            </p>
            <p>
              Bieri hofft, dass die Schweizer Politik und die Medizin sich des
              Themas Long Covid ambitionierter annehmen werden. Aufgrund des
              komplexen Krankheitsbildes fühle sich bis jetzt niemand wirklich
              zuständig für sie; und wegen der fehlenden Sichtbarkeit würden
              Long-Covid-Betroffene oft vergessen.
            </p>
          </div>
        </div>
      </div>

      {/* ZITAT */}
      <div className='ui relaxed vertical segment'>
        <div className='ui text container inverted'>
          <div className='ta text'>
            <div className='personName'>Bruno Bucher (65), Biel</div>
            <div className='personByline'>
              pensionierter Professor für Wirtschaft
            </div>
          </div>
        </div>
        <div className='quoteWrapper'>
          <div className='row two right'>
            <div className='column image'>
              <img src={require('images/bruno-bucher.jpg')} />
              <div className='caption'>Foto: Andreas Seibert/Pro Litteris</div>
            </div>
            <div className='column text'>
              <div className='quote'>
                <div>
                  «Ich hatte Mühe, die richtigen Worte zu finden und einen
                  Gedanken zu Ende zu denken.»
                </div>
                <div className='byline'>Bruno Bucher (65)</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical segment portrait'>
        <div className='ui text container inverted'>
          <div className='ta text'>
            <p>
              Am 28. Oktober 2020 schreibt Bruno Bucher auf seiner
              Facebook-Seite: «Es wird jetzt ungemütlich. Meine Frau pflegte
              unwissentlich zwei Covid-Infizierte, die sich das Virus offenbar
              im Spital geholt haben.» Kurz darauf wird sie positiv auf Covid-19
              getestet, am 5. November dann auch Bruno Bucher selber, der an
              einer Vorerkrankung leidet.
            </p>
            <p>
              Da sich der Zustand seiner Frau innerhalb von Stunden dramatisch
              verschlechtert, wird sie ins Spital verlegt. Auch Bucher fühlt
              sich mit jeder Stunde schlechter. Eines Morgens kann er sich kaum
              noch auf den Beinen halten. Er ruft die Ambulanz und wird in das
              Krankenzimmer seiner Frau gebracht. Innerhalb eines Tages hat sie
              sich so stark verändert, dass er sie zuerst kaum wiedererkennt.
              Sie erholt sich aber und kann nach einiger Zeit entlassen werden.
            </p>
            <p>
              Buchers Zustand jedoch verschlechtert sich, er bekommt zeitweise
              kaum noch Luft.
            </p>
            <p>
              Innerhalb der drei Wochen, die Bucher im Spital verbringt,
              verliert er 12 Kilogramm Körpergewicht. Danach beginnt ein
              vierwöchiger Aufenthalt in der Schweizer Rehaklinik
              Heiligenschwendi.
            </p>
            <p>
              Die Corona-Infektion führt bei Bucher zu Haarausfall und
              Geschmacksstörungen: Alles, was er essen oder trinken will, riecht
              und schmeckt scheusslich.
            </p>
            <p>
              Auch Buchers Denkkapazität und sein Erinnerungsvermögen haben
              durch die Infektion gelitten: Ab und an hat er Mühe, die richtigen
              Worte zu finden, einen Gedanken zu Ende zu denken. Als Kopfmensch
              fällt es ihm schwer, diese Veränderungen zu akzeptieren. Neulich
              sei er vor seinem Computer eingeschlafen, das sei ihm früher nie
              passiert.
            </p>
            <p>
              Bucher bedauert, dass es in der Schweiz zu Long Covid keine
              adäquate Forschung gebe und keine Massnahmen, die den Betroffenen
              helfen würden. «Als Gesellschaft hat die Schweiz in der
              Corona-Pandemie versagt.»
            </p>
          </div>
        </div>
      </div>

      {/* ZITAT */}
      <div className='ui relaxed vertical segment'>
        <div className='ui text container inverted'>
          <div className='ta text'>
            <div className='personName'>Chantal Britt (53), Bern</div>
            <div className='personByline'>Kommunikationsfachfrau</div>
          </div>
        </div>
        <div className='quoteWrapper'>
          <div className='row two left'>
            <div className='column image'>
              <img src={require('images/chantal-britt.jpg')} />
              <div className='caption'>Foto: Andreas Seibert/Pro Litteris</div>
            </div>
            <div className='column text'>
              <div className='quote'>
                <div>
                  «Diese unsichtbare Erkrankung stellt seit zwei Jahren mein
                  Leben auf den Kopf und macht meinen Körper kaputt.»
                </div>
                <div className='byline'>Chantal Britt (53)</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical segment portrait'>
        <div className='ui text container inverted'>
          <div className='ta text'>
            <p>
              Chantal Britt, dreifache Mutter, war so gut wie nie
              krankgeschrieben, hat nie bei der Arbeit gefehlt. Sie war fit und
              sportlich, sie spielte Tennis und Squash, fuhr Ski und lief
              Marathon.
            </p>
            <p>
              Bei einem Konzert im Februar 2020 mit 200 Jugendlichen und 500
              Zuschauern, alle ohne Masken, infiziert sich Britt mit Sars-CoV-2.
              Ihr Krankheitsverlauf ist mild, sie spürt ein Kratzen im Hals, und
              sie hüstelt, ansonsten zeigt sie keine weiteren Anzeichen einer
              Erkrankung. Erst Mitte März kommen schwerere Symptome wie
              Kurzatmigkeit, Atemnot bei Belastung, Schmerzen im Brustkorb und
              Herzrasen hinzu.
            </p>
            <p>
              Ein PCR-Test Anfang April ist negativ, ebenfalls ein
              Antikörpertest. Auch Ende September sind ihre Symptome nicht
              verschwunden. Ihr Pneumologe spricht von Psychosomatik, und Britt
              gründet mit weiteren Long-Covid-Betroffenen die Facebook-Gruppe
              «Long Covid Schweiz».
            </p>
            <p>
              Im März 2021, ein Jahr nach ihrer Covid-19-Erkrankung, sind Britts
              Hauptsymptome noch immer präsent, vermehrt treten nun auch Fatigue
              und kognitive Defizite auf. Im Juni wird die Diagnose
              «Post-Covid-Syndrom mit Fatigue» gestellt. «Nach meinen ruhelosen
              Nächten, die keine Erholung bringen, habe ich Mühe aufzustehen.
              Ich fühle mich leer und wie verkatert, ohne den unterhaltsamen
              Teil am Abend davor», schildert Britt ihre Symptome. «Ich habe
              Mühe, Bücher zu lesen, weil ich alles gleich wieder vergesse. Ich
              traue mich nicht mehr, Auto zu fahren, weil ich mich nicht
              konzentrieren kann.»
            </p>
            <p>
              Heute, zwei Jahre nach ihrer Erkrankung, sind die Symptome
              unverändert spürbar. Sie leidet an Belastungsintoleranz, an Brain
              Fog, Fatigue, an Kurzatmigkeit, und sie erlebt eine generelle
              Lethargie und grosse Antriebslosigkeit.
            </p>
            <p>
              «Diese unsichtbare Erkrankung, die mein Leben so lange auf den
              Kopf stellt und meinen Körper kaputt macht, hat mich über 10 Jahre
              altern lassen. Jeder Tag ist ein Kampf», sagt Britt. «Ich wünsche
              diese Krankheit meinem ärgsten Feind nicht.»
            </p>
          </div>
        </div>
      </div>

      {/* ZITAT */}
      <div className='ui relaxed vertical segment'>
        <div className='ui text container inverted'>
          <div className='ta text'>
            <div className='personName'>Mirjam Lüscher (46), Basel</div>
            <div className='personByline'>
              Mitarbeiterin einer schulischen Tagesstruktur
            </div>
          </div>
        </div>
        <div className='quoteWrapper'>
          <div className='row two right'>
            <div className='column image'>
              <img src={require('images/mirjam-luescher.jpg')} />
              <div className='caption'>Foto: Andreas Seibert/Pro Litteris</div>
            </div>
            <div className='column text'>
              <div className='quote'>
                <div>
                  «Das Leben ist wie ein Zug. Ich aber stehe am Bahnhof und
                  schaue zu, wie dieser an mir vorbeifährt.»
                </div>
                <div className='byline'>Mirjam Lüscher (46)</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical segment portrait'>
        <div className='ui text container inverted'>
          <div className='ta text'>
            <p>
              Durch das Stubenfenster sind Flugzeuge am stahlblauen Himmel zu
              sehen. Scheinbar mühelos gewinnen sie nach dem Start an Höhe. Dann
              drehen sie nach Westen ab und sind kurz darauf nur noch als kleine
              schwarze Punkte zu erkennen. Neulich erst wollte Mirjam Lüscher
              eines der Fenster reinigen. Nach wenigen Minuten begann ihr Herz
              zu rasen, und sie musste aufhören.
            </p>
            <p>
              Vor ihrer Coronainfektion Anfang Oktober 2020 ist Lüscher gesund
              und sportlich. Am 7. Oktober bekommt sie Fieber und bleibt gut
              drei Wochen in Selbstisolation zu Hause – trotz Atemnot. Auch nach
              der akuten Infektionsphase fühlt sie sich nicht gesund. Da ihr
              Hausarzt nicht glaubt, dass es Long Covid gibt, und sie nicht
              krankschreiben will, sucht sich Lüscher einen neuen Mediziner, der
              sie betreut. Die Arbeit beginnt sie mit reduziertem Pensum und
              mithilfe von Asthma- und Schmerzmedikamenten. Kurz darauf
              verschlechtert sich ihr Zustand, und sie muss ihre Weiterbildung
              unterbrechen.
            </p>
            <p>
              Nach der Impfung im Sommer 2021 verbessert sich Lüschers Zustand
              ein wenig, doch dieses Hoch ist nur von kurzer Dauer. Nach etwa
              zwei Wochen kehren die meisten Symptome zurück. Lüscher besucht
              heute eine Long-Covid-Sprechstunde mit ambulanten Therapien. Da
              sie zu hundert Prozent arbeitsunfähig ist, wird ihr in der
              Sprechstunde empfohlen, sich bei der IV anzumelden. Doch sie wäre
              lieber weiterhin berufstätig.
            </p>
            <p>
              In ihrem Freundeskreis nimmt das Verständnis für ihre Situation
              unterdessen ab: Sie solle mehr Sport machen und früher ins Bett
              gehen; jeder sei mal müde; sie solle sich nicht dauernd mit Long
              Covid beschäftigen, das tue natürlich nicht gut. Sie würde gerne
              ihre Arbeit wiederaufnehmen und mit ihrer Weiterbildung
              fortfahren; würde gerne wieder Sport treiben, Feste besuchen und
              Freundinnen treffen. Aber sie kann nicht. Ihr Leben mit Long
              Covid, sagt sie, sei wie ein Zug, in dem sie nicht sitze. Sie
              stehe am Bahnhof und sehe zu, wie der Zug an ihr vorbeiziehe.
            </p>
          </div>
        </div>
      </div>

      {/* ZITAT */}
      <div className='ui relaxed vertical segment'>
        <div className='ui text container inverted'>
          <div className='ta text'>
            <div className='personName'>Lara Karcher (31), Muttenz&nbsp;BL</div>
            <div className='personByline'>
              Online Campaign and Content Manager
            </div>
          </div>
        </div>
        <div className='quoteWrapper'>
          <div className='row two left'>
            <div className='column image'>
              <img src={require('images/lara-karcher.jpg')} />
              <div className='caption'>Foto: Andreas Seibert/Pro Litteris</div>
            </div>
            <div className='column text'>
              <div className='quote'>
                <div>
                  «Eines Morgens bin ich mit einer schwarzen Zunge aufgewacht.»
                </div>
                <div className='byline'>Lara Karcher (31)</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical segment portrait'>
        <div className='ui text container inverted'>
          <div className='ta text'>
            <p>
              Ende 2019 reist eine Arbeitskollegin von Lara Karcher für vier
              Wochen nach China. Als sie zurück in der Firma ist, werden mehrere
              ihrer Kollegen und Kolleginnen krank, einige von ihnen entwickeln
              Lungenentzündungen. Auch Karcher erkrankt. Nach ihrer
              Coronainfektion entwickelt sie ganz unterschiedliche Symptome: Sie
              leidet unter Geschmacksverlust, hat Husten, Hautprobleme,
              Zuckungen und Haarausfall. Von den Ärzten, die sie aufsucht, fühlt
              sie sich nicht ernst genommen. Als sie eines Morgens mit einer
              schwarzen Zunge aufgewacht sei, habe ihr Arzt am Telefon gefragt,
              ob sie Blaubeeren gegessen habe.
            </p>
            <p>
              Ihre Fingernägel, die ihr zuvor bei einer gewissen Länge oft
              abbrachen, werden steinhart, es kommt ihr vor, als würden ihr
              Klauen wachsen. Karcher versteht ihren Körper nicht mehr.
            </p>
            <p>
              Bis jetzt hat sie keine Therapie gegen ihre Symptome gefunden.
              Eine Ärztin empfahl ihr eine psychiatrische Behandlung. Da sie
              sich so früh infiziert hat, konnte man bei einem Test Mitte 2020
              keine Antikörper nachweisen. Unterdessen hat sie aber die
              Bestätigung, dass sie von Long Covid betroffen ist.
            </p>
          </div>
        </div>
      </div>

      {/* ZITAT */}
      <div className='ui relaxed vertical segment'>
        <div className='ui text container inverted'>
          <div className='ta text'>
            <div className='personName'>
              Patrizia Lang (32), Eschlikon&nbsp;TG
            </div>
            <div className='personByline'>vierfache Mutter</div>
          </div>
        </div>
        <div className='quoteWrapper'>
          <div className='row two right'>
            <div className='column image'>
              <img src={require('images/patrizia-lang.jpg')} />
              <div className='caption'>Foto: Andreas Seibert/Pro Litteris</div>
            </div>
            <div className='column text'>
              <div className='quote'>
                <div>
                  «Wir mussten die Hälfte unseres Einkommens für die
                  Kinderbetreuung ausgeben.»
                </div>
                <div className='byline'>Patrizia Lang (32)</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical segment portrait'>
        <div className='ui text container inverted'>
          <div className='ta text'>
            <p>
              Anfang 2020 scheint Patrizia Langs Glück perfekt. Die Familie
              zieht in ein schönes Haus in Eschlikon im Thurgau, und am 15. März
              kommt ihr viertes Kind zur Welt. Am 6. November erkrankt Patrizia
              Lang jedoch an Covid. Sie hat Fieber, für sie neuartige
              Kopfschmerzen, Gliederschmerzen und Atembeschwerden. Dazu kommen
              Schwindel und das Gefühl, gleich ohnmächtig zu werden. Eine
              Ambulanz bringt sie ins Spital.
            </p>
            <p>
              Neurologisch scheint sie gesund zu sein und wird wieder entlassen.
              Ihr Mann, ebenfalls an Covid erkrankt, erholt sich. Auch ihr
              Zustand verbessert sich, aber nur für kurze Zeit. Nun leidet sie
              unter Taubheitsgefühlen in Armen und Beinen, Muskelschwäche,
              unsicherem Gang, Durchfall, Übelkeit, Druck im Kopf, Ausschlägen,
              Haarausfall. Im neuen Jahr geht es ihr zusehends schlechter. Es
              kommen Sehstörungen hinzu, Geruchshalluzinationen und Atemnot bei
              der kleinsten Anstrengung. Beim Gehen hat sie das Gefühl, Kisten
              vor sich herzuschieben. Beim Gang zur Toilette rast ihr Herz wie
              bei einem Marathon.
            </p>
            <p>
              Lang kann ihre vier Kinder nicht mehr selber betreuen und sucht
              Hilfe beim Roten Kreuz. Als sie erneut kollabiert, wird sie ein
              weiteres Mal ins Krankenhaus gebracht. Mit der dortigen Behandlung
              ist sie nicht zufrieden. Erst als sie ins Universitätsspital
              Zürich verlegt wird, erhält sie die Diagnose Long Covid. Es folgen
              mehrere Wochen Rehabilitation in Liechtenstein. In dieser Zeit
              verpasst sie den dritten und den fünften Geburtstag ihrer Söhne,
              den jüngsten hat sie in der Reha und im Krankenhaus bei sich.
              Seinen ersten Geburtstag muss Lang mit ihm alleine feiern, ohne
              ihre Familie. Als sie wieder zu Hause ist, fühlt sie sich alleine
              gelassen, denn sie ist immer noch krank, erhält keine staatliche
              Unterstützung, keine Therapie und keine Medikamente, die wirklich
              helfen.
            </p>
            <p>
              Nach der zweiten Moderna-Impfung bekommt sie Sehstörungen. Im
              Universitätsspital Zürich lautet der Verdacht auf das
              Visual-Snow-Syndrom. Derzeit ist sie deshalb im Inselspital Bern
              in Behandlung. Nie hätte sie gedacht, dass sie so lange krank sein
              würde. Ihr Baby, sagt Lang, habe viel Farbe in ihre schwierige
              Situation gebracht. In der Reha habe der Junge laufen gelernt und
              ihr täglich gezeigt, wie man nach dem Hinfallen wieder aufstehe.
            </p>
          </div>
        </div>
      </div>

      {/* ZITAT */}
      <div className='ui relaxed vertical segment'>
        <div className='ui text container inverted'>
          <div className='ta text'>
            <div className='personName'>
              Geneviève Morin (59), Basel und Hégenheim
            </div>
            <div className='personByline'>bildende Künstlerin</div>
          </div>
        </div>
        <div className='quoteWrapper'>
          <div className='row two left'>
            <div className='column image'>
              <img src={require('images/genevieve-morin.jpg')} />
              <div className='caption'>Foto: Andreas Seibert/Pro Litteris</div>
            </div>
            <div className='column text'>
              <div className='quote'>
                <div>
                  «Die Erkrankung löste bei mir manisch-depressive Phasen aus.»
                </div>
                <div className='byline'>Geneviève Morin (59)</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical segment portrait'>
        <div className='ui text container inverted'>
          <div className='ta text'>
            <p>
              Der Husten beginnt Mitte März 2021. Kurz darauf setzt heftiges
              Fieber ein. Geneviève Morin begibt sich zu Hause in
              Selbstisolation. In der Nacht vom 23. März hat sie einen
              schrecklichen Albtraum: Mit wahnsinnigem Tempo dreht sich eine Art
              CD in ihrem Kopf. Immer an der gleichen Stelle wird sie plötzlich
              gestoppt. Im Traum erkrankt sie an Alzheimer und versucht immer
              wieder, klare Gedanken zu fassen, ist aber dazu nicht in der Lage.
              Völlig erschöpft wacht sie auf und meint, sie sei tatsächlich an
              Alzheimer erkrankt. Aus Angst vor diesem Traum will sie nicht mehr
              schlafen, meidet ihr Bett und liegt auf dem Sofa in ihrem
              Wohnzimmer. Am frühen Morgen des 26. März beginnt ihr Herz
              unregelmässig zu schlagen. Morin ist überzeugt, dass sie nicht an
              Corona, sondern an einem Herzschlag sterben wird, und ruft ihre
              Ärztin an.
            </p>
            <p>
              Kurz darauf steht ein Notfallteam in Schutzkleidung vor ihrer Tür,
              und Morin wird mit einer Lungenentzündung notfallmässig ins
              Krankenhaus gebracht. Dort bleibt sie bis Ende März.
            </p>
            <p>
              Dann entwickelt sie eine manische Phase, in der sie drei Tage lang
              ohne Unterbruch telefoniert. Sie geht davon aus, dass ihre
              Coronainfektion die manisch-depressiven Phasen, an denen sie vor
              29 Jahren bereits litt, die sie aber unter Kontrolle hatte, erneut
              ausgelöst hat.
            </p>
            <p>
              Den April verbringt sie in einem Haus im Basler Jura, um sich zu
              erholen. Dann setzen depressive Phasen ein, die so schlimm werden,
              dass sie in der Psychiatrischen Klinik der Universität Basel Hilfe
              sucht. Dort verbringt sie den ganzen Juli. Im August folgt ein
              Aufenthalt in der Klinik Sonnenhalde in Riehen. Der behandelnde
              Arzt stellt die Diagnose Long Covid und bestätigt Morins
              Vermutung, dass die Erkrankung bei ihr erneut manisch-depressive
              Phasen ausgelöst hat.
            </p>
            <p>
              Danach beginnt Morin langsam wieder mit ihrer künstlerischen
              Arbeit. Da ihre Werke sehr persönlich sind, geht sie davon aus,
              dass ihre Erlebnisse während und nach ihrer Covid-Erkrankung immer
              wieder in ihre Kunst einfliessen werden.
            </p>
          </div>
        </div>
      </div>

      {/* ZITAT */}
      <div className='ui relaxed vertical segment'>
        <div className='ui text container inverted'>
          <div className='ta text'>
            <div className='personName'>Sina Kuhn (40), Zürich</div>
            <div className='personByline'>Senior Consultant</div>
          </div>
        </div>
        <div className='quoteWrapper'>
          <div className='row two right'>
            <div className='column image'>
              <img src={require('images/sina-kuhn.jpg')} />
              <div className='caption'>Foto: Andreas Seibert/Pro Litteris</div>
            </div>
            <div className='column text'>
              <div className='quote'>
                <div>
                  «Mittlerweile sind kleine Ausflüge möglich, wenn ich mich
                  danach erholen kann.»
                </div>
                <div className='byline'>Sina Kuhn (40)</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical segment portrait'>
        <div className='ui text container inverted'>
          <div className='ta text'>
            <p>
              Sina Kuhn erkrankt im September 2020 mittelschwer an Covid. Die
              Krankheit dauert rund drei Wochen und fühlt sich wie eine schwere
              Grippe an. In dieser Zeit ist sie alleine zu Hause in Isolation.
              Als sie sich besser fühlt, fährt sie nach Baden, um ihren Partner
              zu besuchen. Sie bekommt aber kaum Luft und schafft es nur knapp
              bis zu seiner Haustür. Der behandelnde Pneumologe meint, ihre
              Atemnot sei psychisch bedingt, sie solle sich beruhigen.
            </p>
            <p>
              Vor ihrer Coronainfektion war Kuhn gesund. Sie achtete auf ihren
              Körper, praktizierte jeden Tag Yoga, tanzte Salsa, trieb viel
              Sport, ging wandern. Heute kann sie ihren Körper nicht mehr
              richtig einschätzen. Sobald sie über ihre Leistungsgrenze
              hinausgeht – die viel tiefer ist als vor der Infektion –, erlebt
              sie einen «Crash». Dann muss sie sich hinlegen, möglichst alles
              ausblenden, vor allem Licht und Geräusche. Bis sie sich erholt
              hat, braucht sie etwa zwei Tage.
            </p>
            <p>
              Nach ihrer ersten Coronaimpfung im Juni 2021 verschlechtern sich
              Kuhns Symptome enorm. Seither ist sie relativ stark von Long Covid
              betroffen. Auch nach der zweiten Impfung bleiben die Symptome mit
              den typischen Schwankungen bestehen.
            </p>
            <p>
              Im Sommer 2021 gönnen sich Kuhn und ihr Partner eine Ayurvedakur.
              Danach fühlt sie sich fast so gut wie vor ihrer Erkrankung. Sie
              fahren ans Meer, doch als Kuhn ins Wasser watet, erleidet sie
              einen weiteren Crash – für ihren Körper ist der Unterschied
              zwischen Wasser- und Körpertemperatur zu gross.
            </p>
            <p>
              Heute geht es Kuhn nicht besser, aber sie hat ihren Zustand
              akzeptiert und gelernt, mit ihm umzugehen. So sind kleine Ausflüge
              oder Restaurantbesuche möglich – wenn sie sich gut vorbereitet und
              danach erholen kann.
            </p>
          </div>
        </div>
      </div>

      {/* ZITAT */}
      <div className='ui relaxed vertical segment'>
        <div className='ui text container inverted'>
          <div className='ta text'>
            <div className='personName'>
              Christian Salzmann (52), Vordemwald AG
            </div>
            <div className='personByline'>Journalist und Radiomoderator</div>
          </div>
        </div>
        <div className='quoteWrapper'>
          <div className='row two left'>
            <div className='column image'>
              <img src={require('images/christian-salzmann.jpg')} />
              <div className='caption'>Foto: Andreas Seibert/Pro Litteris</div>
            </div>
            <div className='column text'>
              <div className='quote'>
                <div>
                  «Ich wusste nicht, ob ich meine Partnerin nochmals wiedersehen
                  werde.»
                </div>
                <div className='byline'>Christian Salzmann (52)</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical segment portrait last'>
        <div className='ui text container inverted'>
          <div className='ta text'>
            <p>
              Es ist Oktober 2020, die zweite Coronawelle rollt durch die
              Schweiz. Christian Salzmann und seine Partnerin verabreden, dass
              sie sich gegenseitig keine Vorwürfe machen werden, sollte jemand
              von beiden das Virus nach Hause bringen. Dann erkrankt Salzmanns
              Partnerin, eine Pflegefachfrau, wenig später auch er. Beide
              begeben sich in Isolation und durchleben die Coronainfektion
              alleine.
            </p>
            <p>
              Nach einigen Tagen ruft Salzmanns Partnerin an und sagt, sie
              bekomme keine Luft mehr. Seine Angst ist gross, und da sich auch
              sein Zustand jetzt schnell verschlechtert, weiss er nicht, ob sie
              sich nochmals wiedersehen werden. Unter grosser Anstrengung und
              mit der Hilfe eines befreundeten Notars setzt er sein Testament
              auf. Glücklicherweise erholen sich beide und können ihre Arbeit
              wieder aufnehmen.
            </p>
            <p>
              Vier Wochen später, Salzmann hat soeben eine Radiosendung hinter
              sich, kommt die Krankheit zurück: Plötzlich hat er keine Energie
              mehr. Er bricht fast zusammen, kann sich gerade noch an seinem
              Sendepult festhalten. Auch seiner Partnerin geht es wieder
              schlechter. Seit Dezember 2020 leiden beide an Long Covid.
              Salzmann leidet an Atemnot, chronischer Erschöpfung, wandernden
              Gliederschmerzen, Konzentrationsproblemen, Empfindungsstörungen in
              Armen und Beinen und Schlafstörungen. Immer wieder riecht für ihn
              einige Tage lang alles nach Autoabgasen. Hektik und Stress
              verträgt er nur noch schlecht. Die massive Depression, in die
              Salzmann kurz nach Beginn der Long-Covid-Erkrankung gestürzt ist,
              hat inzwischen nachgelassen. Allerdings kommen immer wieder
              depressive Verstimmungen zurück.
            </p>
            <p>
              Salzmann begibt sich für neun Wochen in Rehabilitation. Während es
              ihm langsam etwas besser geht, verschlechtert sich der Zustand
              seiner Partnerin erneut.
            </p>
            <p>
              Heute muss er sich entscheiden, ob er einkaufen geht oder einen
              Spaziergang macht; für beides reicht seine Energie nicht. Nicht zu
              wissen, wie lange er von Long Covid betroffen sein wird, macht ihm
              Angst. Hoffnung geben ihm verständnisvolle Menschen in seinem
              Umfeld, sein Glaube und die Erforschung neuer Medikamente gegen
              Long Covid.
            </p>
            <p>
              Wenn Salzmann wieder gesund ist, so hat er sich vorgenommen, wird
              er vieles nicht mehr so ernst und nicht so persönlich nehmen wie
              vor seiner Coronainfektion. Und er will für Menschen da sein, die
              Hilfe brauchen – so wie er jetzt.
            </p>
          </div>
        </div>
      </div>

      {/* Chapter 2 */}
      <div className='ui vertical segment interview author' id='interview'>
        <div className='ui text container' style={{ marginTop: '2em' }}>
          <div className='ta text'>
            <div className='introPerson'>
              <div className='imageWrapper'>
                <img src={require('images/andreas-seibert.jpg')} />
              </div>
              <p>
                <span>Andreas Seibert</span> ist Fotograf und war Mitglied der
                Agentur Lookat. Er hat sechzehn Jahre in Japan gelebt. Seit
                Beginn des Jahrtausends dokumentiert er fotografisch den
                chinesischen Wirtschaftsboom. Long-Covid-Betroffene fotografiert
                er seit dem Sommer 2021. Mehr Informationen auf{' '}
                <Link href='https://www.andreasseibert.com'>
                  andreasseibert.com
                </Link>
                .
              </p>
            </div>
            <h4 style={{ marginBottom: '1em' }}>
              «Es braucht Mut, die eigene Versehrtheit zu zeigen»
            </h4>

            <div className='question'>
              Woher kommt Ihr Interesse an Long Covid?
            </div>
            <p>
              Ab Sommer 2021, als viele Menschen die Hoffnung hatten, die
              Pandemie gehe ihrem Ende entgegen, ich übrigens auch, las ich
              zunehmend Meldungen und Studien, die darauf hindeuteten, dass ein
              beträchtlicher Anteil der Corona-Infizierten Long-Covid-Symptome
              entwickeln. An den Pressekonferenzen des Bundes allerdings war
              Long Covid kaum ein Thema. Das hat mich sehr irritiert und
              veranlasst, diesem Thema selber nachzuforschen. Nach ersten
              Telefongesprächen mit Long-Covid-Betroffenen wurde mir klar, dass
              sie keine Stimme haben, dass sie von der Öffentlichkeit kaum
              wahrgenommen werden und dass ihr Leidensdruck sehr hoch ist. All
              dies hat mich dazu bewogen, mit der fotografischen Arbeit an
              dieser Serie zu beginnen.
            </p>

            <div className='question'>
              Was haben Sie für Personen angetroffen?
            </div>
            <p>
              Ich habe Personen kennen gelernt, die mir mit grosser Offenheit
              von ihrer akuten Corona-Infektion erzählten, vom Beginn ihrer
              Long-Covid-Erkrankung, von den fehlenden Therapien und ihren
              Reha-Aufenthalten. Sie haben von ihren Ängsten und Hoffnungen
              gesprochen und von ihren Enttäuschungen, die sie durch Begegnungen
              mit Ärzten, aber auch durch Erfahrungen im Freundeskreis erlebt
              haben. All dies ganz ohne Selbstmitleid oder Larmoyanz. Ich weiss
              nicht, ob ich selber diese Grösse hätte. Ich habe auch Menschen
              getroffen, die durch Long Covid ihr früheres Leben verloren haben
              und nicht wissen, wann oder gar ob sie dieses jemals wieder
              zurückerhalten werden. Kurz, ich habe sehr starke Personen
              angetroffen.
            </p>

            <div className='question'>
              Was hat Sie bei den Begegnungen mit Betroffenen am tiefsten
              beeindruckt?
            </div>
            <p>
              Am meisten wohl die Bereitschaft der Long-Covid-Betroffenen, mir
              und meiner Kamera zu vertrauen. Wenn wir fotografiert werden,
              wollen wir uns von unserer besten Seite zeigen, das ist
              verständlich. Bei dieser Arbeit hingegen war ich darauf
              angewiesen, dass die Betroffenen ihre eigene Verletzlichkeit nicht
              verstecken. Es braucht oft nicht viel, um diese sichtbar zu
              machen, ein neuer Blick, eine andere Körperspannung oder -haltung
              kann ausreichen, um einen Menschen ganz und gar anders
              wahrzunehmen. Aber es braucht Mut, die eigene Versehrtheit
              sichtbar zu machen und diese sodann auf dem Bild auszuhalten und
              zu akzeptieren. Und es braucht sehr viel Mut, sie einer
              Öffentlichkeit zu zeigen. Für diese Bereitschaft möchte ich mich
              nochmals bei allen Beteiligten herzlich bedanken.
            </p>

            <div className='question'>
              Wie fotografiert man eine Krankheit, die zu grossen Teilen
              unsichtbar ist?
            </div>
            <p>
              Als ich die ersten Long-Covid-Betroffenen kontaktiert habe, wurde
              ich oft gefragt: «Herr Seibert, wie wollen Sie Long Covid
              fotografieren, man sieht mir die Krankheit ja nicht an?» Meine
              Antwort war immer: «Ich weiss es nicht. Ich weiss nicht, ob man
              Long Covid fotografieren kann. Aber wenn man es kann, dann werden
              wir es gemeinsam herausfinden.»
            </p>

            <div className='question'>Was haben Sie herausgefunden?</div>
            <p>
              Es ist in der Tat so, dass man den Betroffenen ihre
              Krankheitssymptome oft nicht ansieht. Als Fotograf, der das Medium
              immer auch dokumentarisch einsetzt, hat mich hier die Frage
              interessiert, ob ich etwas, das nicht wirklich sichtbar ist,
              visuell trotzdem einfangen kann. Meine Annahme war, dass eine
              Krankheit, die einen über lange Zeit stark belastet, für die es
              nach wie vor keine ursächliche Therapien gibt, für die man sich
              immer wieder rechtfertigen und erklären muss und von der man nicht
              weiss, wie lange sie noch anhält und ob man von ihr jemals wieder
              geheilt wird, Spuren am Menschen hinterlässt. Spuren im
              Gesichtsausdruck, in der Körperhaltung. Somit bestand meine Arbeit
              als Fotograf darin, diese Spuren, manchmal ganz kleine,
              aufzuzeigen und festzuhalten.
            </p>

            <div className='question'>Wie geht es mit dem Projekt weiter?</div>
            <p>
              Momentan plane ich, rund 80 Long-Covid-Betroffene zu fotografieren
              und ihre Erlebnisse schriftlich festzuhalten. Die Bilder und Texte
              sollen in einem Buch veröffentlicht werden. Falls die
              Corona-Fallzahlen im Herbst 2022 wieder ansteigen, könnte dieses
              Buch einen Beitrag zu einer Diskussion leisten, die uns dann alle
              wieder beschäftigen wird. Mein Anspruch an dieses Buch ist, dass
              es ein fotografisches Zeitdokument eines wichtigen Aspektes der
              Pandemie in der Schweiz darstellt. Sobald die Finanzierung steht,
              geht die Arbeit los.
            </p>
          </div>
        </div>
      </div>

      <Footer
        articleId={ARTICLE_ID}
        questions={[
          'Wie informativ waren die Porträts?',
          'Wie gefällt Ihnen die Gestaltung?'
        ]}
        credits={[
          ['Porträts und Texte', 'Andreas Seibert'],
          ['Interview', 'Marc Brupbacher'],
          ['Digitale Umsetzung', 'Patrick Vögeli'],
          [
            'Hinweis',
            'Einige der Texte und Fotos wurden bereits in der Wochenzeitung (WoZ) vom 27.&nbsp;Januar&nbsp;2022 publiziert.'
          ]
        ]}
      />
    </div>
  )
}
